"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimateFeeType = exports.FeeType = void 0;
/**
 * Fee Types
 */
var FeeType;
(function (FeeType) {
    FeeType["MealPeriodViolation"] = "Meal Period Violation";
    FeeType["LatePayDamagesPerDayLT25"] = "Up to 25 Days (Per Day)";
    FeeType["LatePayDamagesMaximum"] = "Maximum";
    FeeType["LatePayDamagesOnNonPaymentNotice"] = "On Non-Nayment Notice";
    FeeType["LatePayDamagesPerDayAfterNonPaymentNoticeGTE25"] = "Each Day After Non-Payment Notice \u2267 25 days";
})(FeeType || (exports.FeeType = FeeType = {}));
/**
 * Estimate Fee Types
 */
var EstimateFeeType;
(function (EstimateFeeType) {
    EstimateFeeType["WardrobeFee"] = "Wardrobe Fee";
    EstimateFeeType["WardrobeFeeEveningWear"] = "Wardrobe - Fee Evening Wear";
    EstimateFeeType["WardrobeFeePeriodWear"] = "Wardrobe - Fee PeriodWear";
    EstimateFeeType["StudioZoneTravelFee"] = "Studio Zone Travel Fee";
    EstimateFeeType["AuditionScratchTrackFee"] = "Audition Scratch Track Fee";
    EstimateFeeType["LineMemorizationFee"] = "Line Memorization Fee";
    EstimateFeeType["DancersHazardFee1stDay"] = "Dancers Hazard Fee - 1st Day";
    EstimateFeeType["DancersHazardFeeAdditionalDays"] = "Dancers Hazard Fee - Additional Days";
    EstimateFeeType["DancersFootwearFee"] = "Dancers Footwear Fee";
    EstimateFeeType["StuntAdjustmentFee"] = "Stunt Adjustment Fee";
    EstimateFeeType["FlightInsuranceFee"] = "Flight Insurance Fee";
    EstimateFeeType["GroupContractorFee"] = "Group Contractor Fee";
    EstimateFeeType["GroupContractorFee3To5"] = "Group Contractor Fee - 3 To 5";
    EstimateFeeType["GroupContractorFee6To8"] = "Group Contractor Fee - 6 To 8";
    EstimateFeeType["GroupContractorFee9Plus"] = "Group Contractor Fee - 9 Plus";
    EstimateFeeType["PilotSessionFeeStudio"] = "Pilot Session Fee - Studio";
    EstimateFeeType["PilotSessionFeeOnLocation"] = "Pilot Session Fee - On Location";
    EstimateFeeType["WetSnowSmokeDustWorkAllowance"] = "Wet/Snow/Smoke/Dust Work Allowance";
})(EstimateFeeType || (exports.EstimateFeeType = EstimateFeeType = {}));
//# sourceMappingURL=fee-types.js.map